export default __webpack_public_path__ + "static/media/badge.3900277e.svg";